import {PageComponentEnum} from "../Enums/PageComponentEnum";
import {PageInterface} from "./PageInterface";

export interface PageComponentInterface {
	_id: number | string,
	title: string,
	page_id: number,
	type: PageComponentEnum,
	data: any,
	status: boolean,
	sort: number,
	secured: boolean,
	page?: PageInterface,
	show_title: boolean,
}

export class PageComponentClass implements PageComponentInterface {
	_id = -1;
	data = [];
	page_id = -1;
	secured = true;
	sort = -1;
	status = false;
	title = 'Új komponens';
	type = PageComponentEnum.CAROUSEL;
	show_title = false;
}
